
/**
 * API utilities for vehicle registration
 */

// Helper to handle API error responses
export const handleApiError = async (response: Response) => {
  let errorMessage = "Failed to register vehicle";
  
  try {
    const contentType = response.headers.get("content-type");
    
    if (contentType && contentType.indexOf("application/json") !== -1) {
      const errorData = await response.json();
      console.log("API error response:", errorData);
      
      // Handle error object which might have different formats
      if (errorData.detail) {
        errorMessage = errorData.detail;
      } else if (typeof errorData === 'object') {
        // Extract all error messages
        const errors = Object.entries(errorData)
          .map(([key, value]) => {
            if (Array.isArray(value)) {
              return `${key}: ${value.join(', ')}`;
            } else if (typeof value === 'string') {
              return `${key}: ${value}`;
            }
            return null;
          })
          .filter(Boolean)
          .join('; ');
        
        if (errors) {
          errorMessage = errors;
        }
      }
    } else {
      // Not JSON response (like HTML error page)
      errorMessage = `Server error: ${response.status} ${response.statusText}`;
    }
  } catch (parseError) {
    console.error("Error parsing error response:", parseError);
    errorMessage = `Server error (${response.status}): Unable to parse error details`;
  }
  
  return errorMessage;
};

// Register vehicle API call
export const registerVehicle = async (vehicleData: any, token: string | null) => {
  console.log("Sending vehicle data to API:", vehicleData);
  
  if (!token) {
    console.error("No authentication token found");
    throw new Error("You are not logged in. Please log in to register a vehicle.");
  }
  
  try {
    // Log the token for debugging, but mask most of it
    const tokenPreview = token.length > 10 ? 
      `${token.substring(0, 5)}...${token.substring(token.length - 5)}` : 
      '(token too short)';
    console.log(`Using token: ${tokenPreview}`);
    
    // Update the Authorization header to use Token instead of Bearer
    const headers = {
      "Authorization": `Token ${token}`,
      "Content-Type": "application/json",
      "Accept": "application/json"
    };
    
    console.log("Using headers:", Object.keys(headers).join(', '));
    
    const response = await fetch("https://api.discoveryconciergeservices.com/api/v1/vehicles/", {
      method: "POST",
      headers,
      body: JSON.stringify(vehicleData),
    });
    
    console.log("Response status:", response.status);
    console.log("Response headers:", [...response.headers.entries()]);
    
    if (!response.ok) {
      const errorMessage = await handleApiError(response);
      throw new Error(errorMessage);
    }
    
    const responseData = await response.json();
    console.log("Vehicle registered successfully:", responseData);
    
    return responseData;
  } catch (error) {
    console.error("Vehicle registration error:", error);
    throw error;
  }
};
